import { SummaryItem } from '../SummaryItem';
import { SummaryStatus } from '../SummaryStatus';

import type { TypeStatusCount } from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyDeliveryStatusDeliveryProgress.module.scss';

interface DeliveryAgencyDeliveryStatusDeliveryProgressProps {
  deliveryAccepted?: TypeStatusCount;
  deliveryCompleted?: TypeStatusCount;
  deliveryFailed?: TypeStatusCount;
}

const DeliveryAgencyDeliveryStatusDeliveryProgress = ({
  deliveryAccepted,
  deliveryCompleted,
  deliveryFailed,
}: DeliveryAgencyDeliveryStatusDeliveryProgressProps) => {
  return (
    <div className={styles.container}>
      <SummaryItem title="배송 접수">
        <SummaryStatus total={deliveryAccepted?.total ?? 0} current={deliveryAccepted?.count ?? 0} color="#BD76FF" />
      </SummaryItem>
      <SummaryItem title="배송 성공">
        <SummaryStatus total={deliveryCompleted?.total ?? 0} current={deliveryCompleted?.count ?? 0} color="#BD76FF" />
      </SummaryItem>
      <SummaryItem title="배송 실패">
        <SummaryStatus total={deliveryFailed?.total ?? 0} current={deliveryFailed?.count ?? 0} color="#E54445" />
      </SummaryItem>
    </div>
  );
};

export { DeliveryAgencyDeliveryStatusDeliveryProgress };
